import React, { Component } from 'react';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Api from '../Api';
import ImageUri from '../ImageUri';

UIkit.use(Icons);

export default class DashboardCompanyLogo extends Component {
  state = {
    image: '',
    caption: ''
  }

  componentDidMount() {
    this.dataGet();
  }

  dataGet = async () => {
    var {image, caption} = await Api.member('DashboardCompanyLogo');

    this.setState({image: image || '', caption: caption || ''});

  }


  render() {
    return <div className="uk-card uk-card-default uk-padding-small uk-text-center">
      <div style={{height: 160}}>
        {this.state.image !== '' && <img src={ImageUri(this.state.image)} uk-img="" style={{maxHeight: 160}} /> }
      </div>
      <p>{this.state.caption}</p>
    </div>
  }
};
